import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { OrgMember } from "../-components/org-member";

export const Route = createFileRoute("/_authenticated/org/$orgId/members/")({
  component: RouteComponent
});

function RouteComponent() {
  const { org } = useRouteContext({ from: "/_authenticated/org/$orgId/members/" });
  return <OrgMember org={org} />;
}
